import styles from './NotFound404Page.module.scss'

// Color palette friendly 404 SVG
const NotFound404Svg = () => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svg__container}
    >
      <circle cx="80" cy="80" r="80" className={styles.circle1} />
      <g opacity="0.5" filter="url(#filter0_f_3283_29275)">
        <path
          d="M25 53C25 49.6863 27.6863 47 31 47H129C132.314 47 135 49.6863 135 53V114C135 117.314 132.314 120 129 120H31C27.6863 120 25 117.314 25 114V53Z"
          className={styles.path1}
        />
      </g>
      <path
        d="M25 46C25 42.6863 27.6863 40 31 40H129C132.314 40 135 42.6863 135 46V114C135 117.314 132.314 120 129 120H31C27.6863 120 25 117.314 25 114V46Z"
        className={styles.path2}
      />
      <path
        d="M25 46C25 42.6863 27.6863 40 31 40H129C132.314 40 135 42.6863 135 46V50H25V46Z"
        className={styles.path3}
      />
      <ellipse cx="13.4608" cy="64.0001" rx="2.99985" ry="3" className={styles.ellipse1} />
      <path
        d="M84.3387 18.1568C84.7822 16.5115 87.2182 16.5115 87.6616 18.1568L87.894 19.0191C88.0549 19.6163 88.5506 20.0771 89.178 20.2127L89.6617 20.3173C91.4465 20.7032 91.4465 23.1425 89.6617 23.5284L89.178 23.633C88.5506 23.7686 88.0549 24.2294 87.894 24.8266L87.6616 25.6889C87.2182 27.3342 84.7822 27.3342 84.3387 25.6889L84.1064 24.8266C83.9454 24.2294 83.4498 23.7686 82.8223 23.633L82.3386 23.5284C80.5538 23.1425 80.5538 20.7032 82.3386 20.3173L82.8223 20.2127C83.4498 20.0771 83.9454 19.6163 84.1064 19.0191L84.3387 18.1568Z"
        className={styles.path4}
      />
      <circle cx="97" cy="29.3076" r="2" className={styles.circle2} />
      <path
        d="M54.3648 99.0762V92.9661H40V87.2606L53.1914 67.6759H61.2842V87.2606H65.007V92.9661H61.2842V99.0762H54.3648ZM46.9599 87.2606H54.3648V76.2948L46.9599 87.2606Z"
        className={styles.path5}
      />
      <path
        d="M79.8946 99.7236C71.1947 99.7236 67.8767 92.9661 67.8767 83.376C67.8767 73.786 70.952 67.0284 79.8946 67.0284C89.2014 67.0284 91.9934 73.786 91.9934 83.376C91.9934 92.9661 88.6349 99.7236 79.8946 99.7236ZM74.877 92.8042H84.9931V73.9478H74.877V92.8042Z"
        className={styles.path6}
      />
      <path
        d="M109.358 99.0762V92.9661H94.993V87.2606L108.184 67.6759H116.277V87.2606H120V92.9661H116.277V99.0762H109.358ZM101.953 87.2606H109.358V76.2948L101.953 87.2606Z"
        className={styles.path7}
      />
      <path
        d="M70.6472 137.695C71.0906 136.05 73.5266 136.05 73.97 137.695L74.2023 138.558C74.3633 139.155 74.8589 139.616 75.4863 139.751L75.97 139.856C77.7548 140.242 77.7548 142.681 75.97 143.067L75.4863 143.172C74.8589 143.307 74.3633 143.768 74.2023 144.365L73.97 145.227C73.5266 146.873 71.0906 146.873 70.6472 145.227L70.4149 144.365C70.2539 143.768 69.7583 143.307 69.1309 143.172L68.6472 143.067C66.8624 142.681 66.8624 140.242 68.6472 139.856L69.1309 139.751C69.7583 139.616 70.2539 139.155 70.4149 138.558L70.6472 137.695Z"
        className={styles.path8}
      />
      <ellipse cx="98.4608" cy="136" rx="2.99985" ry="3" className={styles.ellipse2} />
      <defs>
        <filter
          id="filter0_f_3283_29275"
          x="12"
          y="34"
          width="136"
          height="99"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="6.5" result="effect1_foregroundBlur_3283_29275" />
        </filter>
      </defs>
    </svg>
  )
}

export default NotFound404Svg
